import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/* Common Modules */
import { TableModule } from '@app/modules/table/table.module';
/* Pipes */
import { PlatformModule } from '@app/platform.module';
import { BenefitsService } from '@benefits/services/benefits.service';
import { AppCommonModule } from '@common/common.module';
import { OrgAccordionItemComponent } from '@employees/components/org-accordion-item/org-accordion-item.component';
/* Components */
import { EmployeesCommonModule } from '@employees/employees.common.module';
/* Module Resolver */
import { EmployeesResolver } from '@employees/employees.resolver';
import { EmployeeRouterModule } from '@employees/employees.routes';
/* Guards */
import { Guards } from '@employees/guards';
/* Module Views */
import { Views } from '@employees/views';
import { TrainingProgramsService } from '@training/services';
import { CompanyFormsModule } from '../forms/company/company-forms.module';
import { DocumentsFormsModule } from '../forms/documents/documents-forms.module';
import { EmployeeFormsModule } from '../forms/employees/employee-forms.module';
import { PerformanceFormsModule } from '../forms/performance/performance-forms.module';
import { TrainingFormsModule } from '../forms/training/training-forms.module';
/* Services */
import { SecurePipe } from '@app/pipes/secure.pipe';
import { BenefitsModule } from '@benefits/benefits.module';
import { OrgChartV2Component } from '@employees/components/org-chart-v2/org-chart-v2.component';
import { KYCKYBStatus } from '../payroll/components/kyc-kyb/kyc-kyb-status/kyc-kyb-status.component';
import { VideosModule } from '../videos/videos.module';
import { Services } from './services';
import { TaxCredit } from './views/employee/job-and-pay/tax-credit/tax-credit.component';

@NgModule({
    imports: [
        PlatformModule,
        EmployeeRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule.forRoot(),
        EmployeesCommonModule,
        TableModule,
        CompanyFormsModule,
        DocumentsFormsModule,
        EmployeeFormsModule,
        PerformanceFormsModule,
        TrainingFormsModule,
        VideosModule,
        BenefitsModule,
        TaxCredit,
        KYCKYBStatus,
    ],
    declarations: [
        ...Views,
        /* Components */
        OrgAccordionItemComponent,
        OrgChartV2Component,
    ],
    providers: [SecurePipe, EmployeesResolver, BenefitsService, TrainingProgramsService, ...Services, ...Guards],
})
export class EmployeesModule {}
